<div class="action-container">
  <h3 class="action-topic">
    <ng-container [ngSwitch]="cardType">
      <ng-container *ngSwitchCase="cardModalType.action">Take Action</ng-container>
      <ng-container *ngSwitchCase="cardModalType.quest">Continue Quests</ng-container>
    </ng-container>
    on Today
  </h3>
  <p class="action-content">
    You've committed to
    <ng-container [ngSwitch]="cardType">
      <ng-container *ngSwitchCase="cardModalType.action">
        trying your first Action! See how it goes, then come back to Today to check it off as complete.
      </ng-container>
      <ng-container *ngSwitchCase="cardModalType.quest">
        starting your first Quest! Find it on Today under "Take Action" to make progress.
      </ng-container>
    </ng-container>
  </p>
  <a class="today-link" routerLink="/today" (click)="closeClicked.emit()">Go to Today</a>
  <button class="button button-reverse button-pill action-button" (click)="closeClicked.emit()">Got It</button>
</div>
